import React, { useState } from 'react'
import Header from './components/Header'
import StepIndicator from './components/StepIndicator'
import Step1Form from './components/Step1Form'
import Step2Summary from './components/Step2Summary'
import Step3Confirm from './components/Step3Confirm'
import Footer from './components/Footer'
import './App.css'

const App = () => {
  const [currentStep, setCurrentStep] = useState(1)
  const [order, setOrder] = useState(null)

  const handleStep1Next = (formData) => {
    setOrder(formData)
    setCurrentStep(2)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  const handleStep2Next = () => {
    setCurrentStep(3)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  const handleStep2Back = () => {
    setCurrentStep(1)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <div className="portal-root">
      {/* Ambient background glows */}
      <div className="portal-glow portal-glow--1" aria-hidden="true" />
      <div className="portal-glow portal-glow--2" aria-hidden="true" />

      <Header />

      <main className="portal-main" id="main-content">
        <StepIndicator currentStep={currentStep} />

        {currentStep === 1 && (
          <Step1Form onNext={handleStep1Next} />
        )}

        {currentStep === 2 && order && (
          <Step2Summary
            order={order}
            onNext={handleStep2Next}
            onBack={handleStep2Back}
          />
        )}

        {currentStep === 3 && order && (
          <Step3Confirm order={order} />
        )}
      </main>

      <Footer />
    </div>
  )
}

export default App
